module.exports = __webpack_public_path__ + "img/2_nike-shorts.95153401.jpg";